function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutlerySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-100 -100 712 712",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8546F"
    },
    d: "M431.999,272H384V8.001l0,0c26.51,0,48,21.49,48,47.999v216H431.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC986"
    },
    d: "M128,208.001L128,208.001c-26.51,0-48-21.491-48-48v-48h95.999v48 C176,186.51,154.51,208.001,128,208.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEB860"
    },
    d: "M281.629,208.001h-3.258c-25.61,0-46.371-20.761-46.371-46.371V54.371 c0-25.61,20.761-46.371,46.371-46.371h3.258c25.61,0,46.371,20.76,46.371,46.371v107.258 C328,187.24,307.239,208.001,281.629,208.001z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.005,
    style: {
      fill: "#1D1D1B"
    },
    width: 16,
    height: 119.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.295,
    style: {
      fill: "#1D1D1B"
    },
    width: 16,
    height: 119.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M167.999,0v160.001c0,22.057-17.944,40-39.999,40s-39.999-17.945-39.999-40V0H72v160.001 c0,28.162,20.899,51.524,48,55.419V512h16V215.419c27.101-3.895,48-27.257,48-55.419V0H167.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M280,0.001c-30.878,0-56,25.12-56,55.999v104c0,28.252,21.034,51.67,48.262,55.452V512h16V215.387 C315.235,211.381,336,188.072,336,160.001V56C336,25.121,310.878,0.001,280,0.001z M320,160.001c0,22.057-17.944,40-40,40 c-22.056,0-39.999-17.945-39.999-40V56c0-22.056,17.944-39.999,40-39.999C302.056,16.001,320,33.946,320,56V160.001z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M280,191.999V176c8.822,0,16-7.179,16-16v-24h16v24C312,177.645,297.645,191.999,280,191.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M392,512h-16V0.001h8c30.878,0,56,25.12,56,55.999v224h-40v-15.999H424V56 c0-19.316-13.765-35.479-31.999-39.196V512H392z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlerySvgrepoCom);
export default __webpack_public_path__ + "static/media/cutlery-svgrepo-com.f777f20c1827785c4075477edb7a55ba.svg";
export { ForwardRef as ReactComponent };